export default function StatusPill({ status = "idle", label }) {
  const cls =
    status === "active"
      ? "cc-status-active text-[#0e8a68]"
      : status === "alert"
      ? "cc-status-alert text-[#ef5757]"
      : "cc-status-idle text-[#5c6877]";
  const text = label || (status === "active" ? "Active" : status === "alert" ? "Alert" : "Idle");
  return (
    <span
      className={`inline-flex items-center gap-[7px] text-[11.5px] font-semibold uppercase tracking-wider ${cls}`}
      data-testid={`status-pill-${status}`}
    >
      <span className="cc-status-dot" />
      {text}
    </span>
  );
}
